<template>
  <TagModal
    v-if="ctx.editMovieTagModal.show"
    title="動画タグの編集"
    v-model="ctx.editMovieTagModal.tags"
    :is-chouki-hozon-tag-disabled="true"
    @close="handleClose"
    @dismiss="ctx.editMovieTagModal.show = false"
  />
</template>

<script setup lang="ts">
import type { ResultTag } from 'src/lib/tagModalHelper';
import { useMovieTagEditStore } from 'src/composables/useMovieTagEdit';

const ctx = useMovieTagEditStore();

const handleClose = async(resultTags: ResultTag[]) => {
  await ctx.updateMovieTagsOfMovieList(resultTags);
  // updateMovieTagsOfMovieList が内部で editMovieTagModal.show = false をセットする
};
</script>
